




















































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbLoadingService } from '@/shared/loading/loading.service';
import splitContent from '@/shared/directive/split-content';
import MainButton from '@/shared/buttons/main-button.component.vue';
import EditButton from '@/shared/buttons/edit-button.component.vue';
import Contract from '@/domain/contract/entity/contract.entity';
import ContractVersionItemRule from '@/domain/contract/entity/contract-version-item-rule.entity';
import ContractService from '@/domain/contract/service/contract.service';
import ContractReadjustment from '@/domain/contract/request/contract-readjustment.entity';
import Strategys from './readjustment-strategy.json';

@Component({
  filters: { splitContent },
  components: {
    VbTooltipSlot,
    EditButton,
    MainButton,
  },
})
export default class Items extends Vue {
  @Prop({
    required: true,
  })
  contract!: Contract;

  @Prop({
    required: true,
  })
  private businessUnitId!: string;

  @Prop({
    required: true,
  })
  isEditable!: boolean;

  @Prop() isAdministratorOrSupervisor!: boolean;

  strategys = Strategys;

  selectedRules = [];

  readjustment: ContractReadjustment = ContractReadjustment.of({})

  editModeValue: boolean = false

  created() {
    this.applyRules();
  }

  applyRules() {
    this.selectedRules = this.contract.currentVersion!!
      .itemRules.filter((el: ContractVersionItemRule) => el.applyReadjustment)
      .map((el) => `${el.id}`);
  }

  @Watch('contract.readjustmentStrategy.value')
  applyStrategyState() {
    if (this.contract.applyAllReadjustmentStrategy || this.contract.customReadjustmentStrategy) {
      this.contract.currentVersion!!.changeAllItemRulesState(true);
    }
    if (this.contract.notApplyReadjustmentStrategy) {
      this.contract.currentVersion!!.changeAllItemRulesState(false);
    }
    this.applyRules();
  }

  get disableRuleSelection(): boolean {
    return this.contract.applyAllReadjustmentStrategy
      || this.contract.notApplyReadjustmentStrategy;
  }

  persistReadjustment() {
    this.readjustment.applyNewReadjustment(
      this.contract.readjustmentStrategy.value, this.selectedRules,
    );
    ContractService.saveReadjustmentConfig(this.businessUnitId, this.contract.id, this.readjustment)
      .then((response: any) => {
        VbSnackbarService.showSuccess('Estratégia de reajuste salva com sucesso');
        this.editModeValue = false;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }
}
